<template>
	<div>
		<div class="title">
			修改密码
		</div>
		<el-row :gutter="10">
		  <el-col :xs="8" :sm="6" :md="4" :lg="3" :xl="2">
			  <div class="grid-content left-title">手机号码：</div>
			</el-col>
		  <el-col :xs="12" :sm="6" :md="8" :lg="9" :xl="6">
			  <div class="grid-content">
				  <el-input placeholder="请输入手机号码" v-model="mobile" ></el-input>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="10" style="margin:20px 0">
		  <el-col :xs="8" :sm="6" :md="4" :lg="3" :xl="2">
			  <div class="grid-content left-title">新密码：</div>
			</el-col>
		  <el-col :xs="12" :sm="6" :md="8" :lg="9" :xl="6">
			  <div class="grid-content">
				  <el-input placeholder="请输入新密码" v-model="newpwd" show-password></el-input>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="10">
		  <el-col :xs="8" :sm="6" :md="4" :lg="3" :xl="2">
			  <div class="grid-content left-title">确认密码：</div>
			</el-col>
		  <el-col :xs="12" :sm="6" :md="8" :lg="9" :xl="6">
			  <div class="grid-content">
				  <el-input placeholder="请确认新密码" v-model="confirmnewpwd" show-password></el-input>
				</div>
			</el-col>
		</el-row>
		<el-row>
		  <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8" style="text-align: center;margin-top: 20px;">
			  <div class="submit"><el-button type="primary" @click="submit">确认修改</el-button></div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default{
		data() {
			return{
				userInfo:{},
				mobile:'',
				newpwd:'',
				confirmnewpwd:'',
			}
		},
		beforeCreate(){
			if(window.localStorage.getItem("token")){
				this.$axios({
					url:this.$utils.httpApi + 'user/getinfos',
					headers:{
						'token':window.localStorage.getItem("token")
					}
				}).then(res=>{
					this.userInfo = res.data
				})	
			}
		},
		methods:{
			submit(){
				if(this.newpwd != this.confirmnewpwd){
					this.$message({
						message:'两次输入的新密码不一致！',
						type:'error'
					})
				}else if(this.mobile != this.userInfo.mobile){
					this.$message({
						message:'手机号码输入错误！',
						type:'error'
					})
				}else{
					this.$axios({
						url:this.$utils.httpApi + 'user/resetpwd',
						data:{mobile:this.mobile,newpassword:this.newpwd},
						method:'post'
					}).then(res=>{
					console.log(res)
					})
				}

			}
		}
	}
</script>

<style scoped>
  .left-title{
	  text-align: right;
	  line-height: 40px;
	  height: 40px;
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
</style>